export enum SeenStatusEnum {
  Pending = 0,
  Seen = 1,
}
